import { Outlet, RouteObject, useMatches, useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

import { getReadablePayMonth } from '@fora-monorepo/employer-my-pages-common/utils';

import { getLastMatchingTitle } from '../utils';
import { routeHandles } from '../../router/routeHandles';
import { EmployerMyPagesLayout } from '../../components';
import { TypedTFunction, useTypedTranslation } from '../../i18n/i18n';

const createBreadcrumbs = (matches: RouteObject['handle'][], t: TypedTFunction) => {
  // Specify crumbs on router handler "AppRouter.tsx"
  return matches
    .filter(match => Boolean(match.handle?.crumb))
    .map(match => {
      // Adds payMonth name to crumb
      const isReportPayrollPage = match.handle.crumb === routeHandles.reportPayroll.crumb;

      return {
        url: match.pathname,
        name: t(
          match.handle.crumb,
          isReportPayrollPage ? { payMonth: getReadablePayMonth(match.params.payMonth) } : undefined
        ),
      };
    });
};

export const BaseLayout = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTypedTranslation();

  const matches: RouteObject['handle'][] = useMatches();
  const breadcrumbs = useMemo(() => createBreadcrumbs(matches, t), [matches, t]);

  const headerTitleData = useMemo(() => getLastMatchingTitle(matches, t), [matches, t]);

  return (
    <EmployerMyPagesLayout
      crumbs={breadcrumbs}
      hasPrintParam={searchParams.has('print')}
      headerTitleData={headerTitleData}
    >
      <Outlet />
    </EmployerMyPagesLayout>
  );
};
